// extracted by mini-css-extract-plugin
export default {"hr":"HrWithText_hr__IhvmF","hrWrap":"HrWithText_hrWrap__aerbv","textWrap":"HrWithText_textWrap__ARJWF"};